import * as React from 'react';

const isKeyboardEvent = (event: unknown): event is KeyboardEvent => {
  return event !== null && typeof event === 'object' && 'key' in event;
};

export const useKeydown = (onKeydown: (event: KeyboardEvent) => void) => {
  React.useEffect(() => {
    const handleKeyDown = (event: unknown) => {
      if (isKeyboardEvent(event)) {
        onKeydown(event);
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onKeydown]);
};
